import type { BadgeType } from '@skytech/ui/Badge'

import type { OrderStatus } from './types'

export function getBadgeTypeFromStatus(status: OrderStatus): BadgeType {
  if (status === 'UNDER CANCELLATION') return 'negative'
  if (status === 'ACTIVE') return 'positive'

  return 'neutral'
}
